<template>
  <v-card-title class="font-weight-regular">
    <v-row dense>
      <v-col cols="12" sm="2">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="exam.date"
              label="Дата"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              dense
              hide-details
              class="mb-3"
            />
          </template>
          <v-date-picker v-model="exam.date" />
        </v-menu>
      </v-col>

      <v-col cols="12" sm="10">
        <v-select
          v-model="exam.state.name"
          :items="states"
          item-text="description"
          item-value="name"
          label="Статус"
          dense
          hide-details
          class="mb-3"
        />
      </v-col>

      <v-col cols="12" sm="2">
        <v-text-field
          v-model="exam.specialityCode"
          label="Код специальности"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="12" sm="10">
        <v-text-field
          v-model="exam.specialityTitle"
          label="Название специальности"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="exam.discipline"
          label="Дисциплина"
          prepend-icon="mdi-teach"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="12">
        <v-select
          v-model="exam.type"
          :items="typeExam"
          item-text="description"
          item-value="name"
          label="Тип"
          prepend-icon="mdi-bookshelf"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="12" sm="2">
        <v-text-field
          v-model="exam.specialityQualification"
          label="Квалификация"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="12" sm="10">
        <v-text-field
          v-model="exam.categoryTitle"
          label="Факультет"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="6" sm="2">
        <v-text-field
          v-model="exam.courseTitle"
          label="Курс"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="6" sm="2">
        <v-text-field
          v-model="exam.groupTitle"
          label="Группа"
          dense
          hide-details
        />
      </v-col>

      <v-col cols="12" class="d-flex justify-end">
        <v-spacer />
        <v-btn text @click="$emit('download', exam)">
          Скачать отчёт(.docx)
        </v-btn>
        <v-btn color="primary" text @click="updateExamSheet(exam)">
          Сохранить
        </v-btn>
        <v-btn color="red" text @click="updateExamSheet(exam.id)">
          Удалить
        </v-btn>
      </v-col>
    </v-row>
  </v-card-title>
</template>

<script>
export default {
  name: "ExamCardTitle",
  props: {
    exam: { type: Object, required: true },
    states: { type: Array, required: true }
  },

  data: () => ({
    typeExam: [
      { name: "credit", description: "Зачёт" },
      { name: "exam", description: "Экзамен" }
    ],
    menu: false
  }),

  methods: {
    updateExamSheet(exam) {
      this.$emit("update", exam);
    }
  }
};
</script>
